import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    if (context.userInfo.state === "LoggedIn") {
      throw redirect({
        to: "/$slug",
        params: { slug: context.userInfo.me.organization.slug },
        replace: true,
      })
    }

    throw redirect({ to: "/sign-in", replace: true })
  },
})
